module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "client-item-box new-line",
    attrs: {
      "data-trackdata": _vm.tData
    }
  }, [_c('div', {
    staticClass: "new-line-box",
    style: ({
      'height': (_vm.lineHeight + "px"),
      'background': ("" + (_vm.data.lineColor))
    })
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40bfbb60"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/renderer-config/components/new-line.vue
// module id = 650
// module chunks = 1 13